var _style, _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDigging = function SvgDigging(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 64,
    height: 64
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".Digging_svg__st0{fill:#fff}")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 24.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 8.6c12.9 0 23.4 10.5 23.4 23.4S44.9 55.4 32 55.4 8.6 44.9 8.6 32 19.1 8.6 32 8.6M32 7C18.2 7 7 18.2 7 32s11.2 25 25 25 25-11.2 25-25S45.8 7 32 7",
    className: "Digging_svg__st0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m51.6 30-3 2.3-1.7 2.2.1.8-.1.1v.3l-.5 1.4v.8l-.6.9-.3 2.6-.9.6-1.1-1.1-2 .5-.3-.6-1.7-.9-1.9-.5-.6-1.1-1.3-.9-.2-.6v-1.4l-1.1-3.9-1.5-1-.2-1-1.5-1.7v-1.4L29.6 25l-.5-1.1-2.3-.9-1.2-1.1-2.2-.7-1.7.8h-1.3l-1.4.6-1.6.6-1.6 1.5v1l-.8.3-1.6 1.4-1 1.5-4 .8v2.9l5.1-1 1.3-1.9 1.2-1.1 1.7-.6v-1.5l.7-.7 1.3-.4 1.1-.5h1.3l1.4-.7 1.1.4 1.2 1 1.9.8.3.7 1.2 1.1v1.4l1.7 1.8.3 1.3 1.5 1 .8 2.8v1.6l.6 1.5 1.5 1 .7 1.4 2.3.6 1.2.7.9 1.2 2.2-.5 1.5 1.5 2.9-2 .3-3.1.6-1v-.9l.5-1.1.3-.8-.1-.6 1-1.3 2.3-1.8h3.2V30z",
    className: "Digging_svg__st0"
  })));
};
export default SvgDigging;